import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useGetXtimeAppointmentIntegrationUrl } from "../../../../queries/useGetXtimeAppointmentIntegrationUrl";
import {
  HashtagString,
  createHashStateHook,
} from "../../../../stores/useHashState";
import { Dialog } from "../../../../ui/Dialog/Dialog";
import { DialogHeader } from "../../../../ui/Dialog/DialogHeader";
import { LinearProgress } from "../../../../ui/LinearProgress";
import { NoData } from "../../../NoData/NoData";

export const appointmentHash: HashtagString = "#appointment";

const useAppointmentState = createHashStateHook(appointmentHash);

export const AppointmentModal: FunctionComponent = () => {
  const [visible, { hide }] = useAppointmentState();
  const { t } = useTranslation();
  const { data, isLoading } = useGetXtimeAppointmentIntegrationUrl();
  return (
    <Dialog
      className={clsx(data && "h-full")}
      id="x-time-appointment-modal"
      onClose={hide}
      placement="top"
      visible={visible}
    >
      <DialogHeader
        className="mb-4"
        onClose={hide}
        subtitle={t("cart.xTimeAppointmentDialogSubtitle")}
        title={t("cart.xTimeAppointmentDialogTitle")}
      />
      {data && (
        <>
          <iframe
            height="100%"
            src={data.xtimeAppointmentIntegrationUrl}
            width="100%"
          />
        </>
      )}
      {isLoading && <LinearProgress className="mt-8" />}
      {!isLoading && !data && (
        <NoData className="my-8 max-w-[12rem] mx-auto">
          {t("cart.xTimeppointmentNodata")}
        </NoData>
      )}
    </Dialog>
  );
};
